var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React, { useEffect, useState } from 'react';
import { useRecoilState, useResetRecoilState } from 'recoil';
import { uploadFromCsvTeacherState } from '../atoms';
import { IconEdit, IconTrash } from '@/presentation/components/icons';
import { ButtonBorderedKVBase, ButtonKVBase, CustomBootstrapTable, DefaultModal, IconButton } from '@/presentation/components';
import useCustomToast from '@/presentation/hooks/use-custom-toast';
import { fromCardinal } from '@/presentation/functions/cardinal';
import ModalEdit from './modal-edit';
import Styles from '../../styles/steps-styles.scss';
import { isMobile } from 'mobile-device-detect';
const columnStyle = { overflowWrap: 'break-word', fontSize: 13, fontWeight: 400 };
const headerStyle = { fontSize: 14, fontWeight: 500 };
const columns = [
    {
        dataField: 'status',
        text: 'Status',
        headerStyle: Object.assign({ width: '10%' }, headerStyle),
        style: columnStyle,
        sort: true
    },
    {
        dataField: 'firstName',
        text: 'First Name',
        headerStyle: Object.assign({ width: '20%' }, headerStyle),
        style: columnStyle,
        sort: true
    },
    {
        dataField: 'lastName',
        text: 'Last Name',
        headerStyle: Object.assign({ width: '20%' }, headerStyle),
        style: columnStyle,
        sort: true
    },
    {
        dataField: 'email',
        text: 'Email',
        headerStyle: Object.assign({ width: '30%' }, headerStyle),
        style: columnStyle,
        sort: true
    },
    {
        dataField: 'classGrade',
        text: 'Class Grade',
        headerStyle: Object.assign({ width: '10%' }, headerStyle),
        style: columnStyle,
        sort: true
    },
    {
        dataField: 'actions',
        text: 'Actions',
        headerStyle: Object.assign({ width: '10%' }, headerStyle),
        style: columnStyle
    }
];
const buildStatus = (flag) => {
    if (flag)
        return React.createElement("span", { className: Styles.validText }, "Valid");
    return React.createElement("span", { className: Styles.failedText }, "Failed");
};
const buildEmpty = () => {
    return React.createElement("span", { className: Styles.emptyText }, "[empty]");
};
function checkString(string) {
    if (string === undefined || string === null || string.trim() === '')
        return false;
    return true;
}
function getDuplicates(items) {
    try {
        const counter = {};
        items.forEach(element => {
            const property = JSON.stringify(element);
            counter[property] = (parseInt(counter[property]) || 0) + 1;
        });
        let duplicateElements = 0;
        Object.keys(counter).forEach(property => {
            if (counter[property] > 1) {
                duplicateElements++;
            }
        });
        return duplicateElements;
    }
    catch (error) {
        return 0;
    }
}
const validateRecordMapped = (record) => {
    if (checkString(record.classGrade) &&
        checkString(record.email) &&
        checkString(record.firstName) &&
        checkString(record.lastName)) {
        return true;
    }
    return false;
};
const mapGrades = (classGrade) => {
    try {
        const gradesString = classGrade.split(',');
        return gradesString.map(fromCardinal);
    }
    catch (error) {
        return [];
    }
};
const deleteEmpty = (list) => {
    return list.filter(item => (item === null || item === void 0 ? void 0 : item.email) || (item === null || item === void 0 ? void 0 : item.firstName) || (item === null || item === void 0 ? void 0 : item.lastName));
};
const Step2 = ({ validation, saveCsvFile, idClient }) => {
    var _a;
    const [state, setState] = useRecoilState(uploadFromCsvTeacherState);
    const resetState = useResetRecoilState(uploadFromCsvTeacherState);
    const [editData, setEditData] = useState({});
    const [teacherForRemove, setTeacherForRemove] = useState({ name: null, key: null });
    const { showCustomError } = useCustomToast({ containerId: 'ModalUploadTeachers' });
    const validateRecord = (record) => {
        if (checkString(record[state.firstNameTableValidation]) &&
            checkString(record[state.lastNameTableValidation]) &&
            checkString(record[state.emailTableValidation]) &&
            checkString(record[state.classGradeTableValidation])) {
            return true;
        }
        return false;
    };
    const deleteRecord = (key, name) => {
        setTeacherForRemove({ key, name });
        toggleModalMessageDelete(true);
    };
    const confirmDeleteRecord = () => {
        if (teacherForRemove.key !== null) {
            const newArray = state.listMapped.filter((i, _key) => _key !== teacherForRemove.key);
            setState(prev => (Object.assign(Object.assign({}, prev), { listMapped: newArray, modalMessageDelete: false })));
            setTeacherForRemove({ name: null, key: null });
        }
    };
    const doEditRecord = (updatedData, { record: recordParam, key: keyParam }) => {
        // console.log(updatedData);
        // console.log(keyParam);
        const newArray = [...state.listMapped];
        newArray[keyParam] = Object.assign(Object.assign({}, newArray[keyParam]), { firstName: updatedData.firstName, lastName: updatedData.lastName, email: updatedData.email, classGrade: updatedData.grades, title: updatedData === null || updatedData === void 0 ? void 0 : updatedData.title });
        newArray[keyParam].status = validateRecordMapped(newArray[keyParam]);
        setState(prev => (Object.assign(Object.assign({}, prev), { listMapped: newArray, modalEditTeacher: false })));
    };
    const editRecord = (record, key) => {
        setEditData({ record, key });
        toggleModalEdit(true);
    };
    const updateSummaryTable = () => {
        const teacherToInvite = state.listMapped.reduce((counter, item) => {
            if (item.status)
                return counter + 1;
            else
                return counter;
        }, 0);
        const issuesFound = state.listMapped.reduce((counter, item) => {
            if (item.status)
                return counter;
            else
                return counter + 1;
        }, 0);
        const duplicates = getDuplicates(state.listMapped);
        setState(prev => (Object.assign(Object.assign({}, prev), { issuesFound, teacherToInvite, duplicates })));
    };
    useEffect(() => {
        updateSummaryTable();
    }, [state.listMapped]);
    useEffect(() => {
        const list = state.fileParsedResult.data.map(record => {
            const status = validateRecord(record);
            const firstName = checkString(record[state.firstNameTableValidation]) ? record[state.firstNameTableValidation] : null;
            const lastName = checkString(record[state.lastNameTableValidation]) ? record[state.lastNameTableValidation] : null;
            const email = checkString(record[state.emailTableValidation]) ? record[state.emailTableValidation] : null;
            const classGrade = checkString(record[state.classGradeTableValidation])
                ? record[state.classGradeTableValidation]
                : null;
            return {
                status,
                firstName,
                lastName,
                email,
                classGrade
            };
        });
        setState(prev => (Object.assign(Object.assign({}, prev), { listMapped: deleteEmpty(list) })));
    }, [state.fileParsedResult]);
    const products = state.listMapped.map((record, key) => {
        return {
            id: key,
            status: buildStatus(record.status),
            firstName: record.firstName || buildEmpty(),
            lastName: record.lastName || buildEmpty(),
            email: record.email || buildEmpty(),
            classGrade: record.classGrade || buildEmpty(),
            actions: (React.createElement("div", { className: Styles.actionWrap },
                React.createElement(IconButton, { className: Styles.icon, onClick: () => editRecord(record, key), "data-testid": `btn-modal-edit-record_${key}` },
                    React.createElement(IconEdit, null)),
                React.createElement(IconButton, { className: Styles.icon, onClick: () => deleteRecord(key, `${record.firstName} ${record.lastName}`), "data-testid": `btn-modal-delete-record_${key}` },
                    React.createElement(IconTrash, null))))
        };
    });
    const toggleModalEdit = (flag) => setState(prev => (Object.assign(Object.assign({}, prev), { modalEditTeacher: flag })));
    const toggleModalMessageDelete = (flag) => setState(prev => (Object.assign(Object.assign({}, prev), { modalMessageDelete: flag })));
    const toggleModalMessageSave = (flag) => setState(prev => (Object.assign(Object.assign({}, prev), { modalMessageSave: flag })));
    const confirmSaveTeachers = () => __awaiter(void 0, void 0, void 0, function* () {
        // console.log('confirmSaveTeachers');
        setState(prev => (Object.assign(Object.assign({}, prev), { isLoading: true, modalMessageSave: false })));
        const listForSave = state.listMapped.filter(item => item.status);
        // console.log(JSON.stringify(listForSave));
        // console.log('antes');
        if (idClient === 0 || idClient === null) {
            alert('idClient is necessary ');
            return;
        }
        const body = {
            idClient,
            teachers: listForSave.map(item => ({
                firstName: item.firstName,
                lastName: item.lastName,
                email: item.email,
                grades: mapGrades(item === null || item === void 0 ? void 0 : item.classGrade),
                title: item === null || item === void 0 ? void 0 : item.title
            }))
        };
        try {
            const response = yield saveCsvFile.saveTeachers(body);
            if (response.results) {
                if (response.totalFailed > 0) {
                    showCustomError('Error', `${response.totalFailed} records failed to be added`);
                }
                console.log('response', response);
                yield resetState();
                setState(prev => (Object.assign(Object.assign({}, prev), { processCompleted: true, recordsInserted: response.totalCreated, recordsFailed: response.totalFailed })));
            }
        }
        catch (error) {
            showCustomError('Error', 'Something went wrong!');
            setState(prev => (Object.assign(Object.assign({}, prev), { isLoading: false })));
        }
        // console.log('despues');
    });
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: Styles.step2Wrap },
            React.createElement(CustomBootstrapTable, { keyField: "id", data: products, columns: columns, showMobile: isMobile })),
        React.createElement(ModalEdit, { editData: editData, modalEditTeacher: state.modalEditTeacher, toggleModalEdit: toggleModalEdit, validation: validation, doEditRecord: doEditRecord }),
        React.createElement(ModalMessage, { isOpen: state.modalMessageDelete, onClose: () => toggleModalMessageDelete(false) },
            React.createElement("div", { className: Styles.modalMessageWrap },
                React.createElement("div", { className: Styles.title }, "Remove a teacher?"),
                React.createElement("div", { className: Styles.detail }, (_a = teacherForRemove === null || teacherForRemove === void 0 ? void 0 : teacherForRemove.name) === null || _a === void 0 ? void 0 : _a.replaceAll('null', '')),
                React.createElement(ButtonKVBase, { type: "button", btnBackgroundGradient: "linear-gradient(90deg, #FFA800 0%, #7F1BFF 100%)", onClick: confirmDeleteRecord, btnWrapClass: Styles.widthAuto, loading: state.isLoading }, "Confirm"),
                React.createElement(ButtonBorderedKVBase, { type: "button", color: '#999999', onClick: () => toggleModalMessageDelete(false) }, "Cancel"))),
        React.createElement(ModalMessage, { isOpen: state.modalMessageSave, onClose: () => toggleModalMessageSave(false) },
            React.createElement("div", { className: Styles.modalMessageWrap },
                React.createElement("div", { className: Styles.title }, "Records with issues won\u2019t be added"),
                React.createElement("div", { className: Styles.detail },
                    "Issues: ",
                    state.issuesFound),
                React.createElement(ButtonKVBase, { type: "button", btnBackgroundGradient: "linear-gradient(90deg, #FFA800 0%, #7F1BFF 100%)", onClick: confirmSaveTeachers, btnWrapClass: Styles.widthAuto, loading: state.isLoading }, "Confirm"),
                React.createElement(ButtonBorderedKVBase, { type: "button", color: '#999999', onClick: () => toggleModalMessageSave(false) }, "Cancel")))));
};
const ModalMessage = ({ isOpen, onClose, children }) => {
    return (React.createElement(DefaultModal, { height: "300", hUnit: "px", width: "432", wUnit: "px", open: isOpen, onClose: onClose, overlayCustomStyles: { zIndex: 10000 } }, children));
};
export default Step2;
